import { Injectable } from '@angular/core';
import {
  createPhotoCapture,
  isDevicePortrait,
  keepTorchOn,
  PhotoCapture,
  REAR_CAMERA_CONSTRAINTS,
  waitForCameraReady
} from './torch-capture';
import { cropToZoom } from './torch-zoom';

@Injectable({ providedIn: 'root' })
export class MediaDevicesGateway {
  public isCameraAvailable(): boolean {
    return typeof navigator !== 'undefined' && !!navigator.mediaDevices?.getUserMedia && window.isSecureContext;
  }

  public openRearCamera(): Promise<MediaStream> {
    return navigator.mediaDevices.getUserMedia(REAR_CAMERA_CONSTRAINTS);
  }

  public waitForCameraReady(video: HTMLVideoElement): Promise<boolean> {
    return waitForCameraReady(video);
  }

  public keepTorchOn(track: MediaStreamTrack): Promise<void> {
    return keepTorchOn(track);
  }

  public createPhotoCapture(track: MediaStreamTrack): PhotoCapture | null {
    return createPhotoCapture(track);
  }

  public isDevicePortrait(): boolean {
    return isDevicePortrait();
  }

  public cropToZoom(image: string, zoom: number, quality: number): Promise<string> {
    return cropToZoom(image, zoom, quality);
  }

  public onPageHidden(callback: () => void): () => void {
    const listener = (): void => {
      if (document.visibilityState === 'hidden') {
        callback();
      }
    };
    document.addEventListener('visibilitychange', listener);
    return () => document.removeEventListener('visibilitychange', listener);
  }
}
